import { ImageLogo } from "./ImageLogo";

import type { CompanylessLogoProps } from "./types";

export function AvantiLogo({ size = "default", testIdPrefix }: CompanylessLogoProps) {
  return (
    <ImageLogo
      size={size}
      testIdPrefix={`${testIdPrefix}-avanti`}
      company={{
        commonName: "Avanti",
        logoUrl: "/avanti_logo.svg",
      }}
    />
  );
}
